import React, {useState, useEffect} from "react";
import { Grommet,ResponsiveContext, Button,Box,Text,Select,Layer} from "grommet";
import { LinkPrevious, Location, Close } from "grommet-icons";
import { GoogleMap, useJsApiLoader, DrawingManager, Polygon } from '@react-google-maps/api';
import SideBar from "../SideBar";
import SideBarMobile from "../SideBarMobile";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { tenant,tenantType,tenantTypeFirstUpperCase } from "../tenant";
import TreeViewAree from "../treeView/TreeView";
import { GET_TREE } from "../registryComponent/aree/areeGQL";
import { GET_HOME ,TRACK_AREA} from "./geoRefGQL";
import { useLazyQuery ,useMutation } from '@apollo/client';

const theme = {
  global: {
    colors: {
      brand: '#397aa3',
      'accent-1': 'white',
      'focus': '#397aa3',
      "my-text-color": "",
      background: '#ecedf3',
    },
    font: {
      family: '',
      size: '18px',
      height: '20px',
    },
    menu:{
      icons:{
        color:'white',
        },
    },
  },
};
const Mappa = (props) => {

const [color, setColor] = React.useState(null);
const [colorSelected, setColorSelected] = React.useState('');
const colors = [
  {key: 'Verde', value: '#009900'},
  {key: 'Giallo', value: '#eed000'},
  {key: 'Blu', value: '#0066ff'},
  {key: 'Rosso', value: '#cc3300'},
  {key: 'Viola', value: '#800080'},
  {key: 'Porpora', value: '#ee82ee'},
  {key: 'Marrone', value: '#a52a2a'},
  {key: 'Nero', value: '#000000'},
  {key: 'Oro', value: '#ffd700'},
  {key: 'Azzurro', value: '#add8e6'},
  {key: 'Verde Chiaro', value: '#90ee90'},
  {key: 'Rosa', value: '#ffc0cb'},
  {key: 'Grigio', value: '#808080'},
  {key: 'Arancione', value: '#ffa500'},
  {key: 'Verde Acqua', value: '#00cc99'},
  {key: 'Verde Erba', value: '#99cc00'},
  {key: 'Argento', value: '#c0c0c0'},
  {key: 'Giallo Ocra', value: '#aea04b'},
  {key: 'Bronzo', value: '#cd7f32'},
  {key: 'Beige', value: '#f5f5dc'},
];

const [tipo, setTipo] = React.useState('');
const tipologie = ["Green", "Aprons", "Rough", "Campo Pratica","Tee", "Bunker", "Fairway", "Collar", "Altro"];

const [adl, setAdl] = React.useState('');
const [zona, setZona] = React.useState('');
const [cantiere, setCant] = React.useState('');


const [poligoni, setPoligoni] = useState([]);
const [polygonRef, setPolygonRef] = useState([]);
const [mostraLayer,setMostraLayer]=React.useState(props.match===undefined?true:false);
const [mostraLayerManual,setMostraLayerManual]=React.useState(false);
let labelBuca="";
const [showSideBarMob,setShowSideBarMob]=React.useState(false);
const [landScapeError,setLandScapeError]=React.useState(false);
/*CHANGE PER IMPLEMENTAZIONE RUOLI*/
const [ruoli, setRuoli] = useState([]);
/*END CHANGE IMPLEMENTAZIONE RUOLI*/
const [selectedNodes,setSelectedNodes]=React.useState([]);
const [tree,setTree]=React.useState({});
const [formData,setFormData]=React.useState({});
const [homeArea,setHomeArea]=React.useState({lat:0,lng:0});
const [savePolygon]=useMutation(TRACK_AREA)
const [polygonsName,setPolygonsName] = React.useState([]);

const [ queryGetTree
] = useLazyQuery(GET_TREE, {
  fetchPolicy: "no-cache",
  onCompleted: (data) => {
     const tree=data[`${tenant}`]["whoami"].profile.treeArea   //[`areas${tenantTypeFirstUpperCase}First`][0].trees;
        if(tree){
          setTree(JSON.parse(tree).tree);
        }
  },
  notifyOnNetworkStatusChange: true, // did the work
});

const [ queryGetHome
] = useLazyQuery(GET_HOME, {
  fetchPolicy: "no-cache",
  onCompleted: (data) => {
   //   console.log(data);
   setFormData({...formData,id:data[tenant][`area${tenantTypeFirstUpperCase}`].id,name:data[tenant][`area${tenantTypeFirstUpperCase}`]["name"],type:data[tenant][`area${tenantTypeFirstUpperCase}`]?.type?.id})
    let coordinates=data[tenant][`area${tenantTypeFirstUpperCase}`]?.coordinates;
   if(coordinates){
       coordinates=coordinates.coordinates?.map((polygon)=>polygon)
      const coordsApp=[];
			for(let i=0;i<coordinates.length;i++){
				for(let z=0;z<coordinates[i].length;z++){
					const polygonPath=coordinates[i][z];
					const path=[];
					for(let j=0;j<polygonPath.length;j++){
                        	if(polygonPath[j][0]>30){
                                path.push({lat:polygonPath[j][0],lng:polygonPath[j][1]})
                            }else{
                                path.push({lat:polygonPath[j][1],lng:polygonPath[j][0]})
                            }


					}
					coordsApp.push({path:path,color:data[tenant][`area${tenantTypeFirstUpperCase}`]?.color || "#000000"});
				}
			}
      if(coordsApp){
        allShapes=[...coordsApp]
        setPoligoni(coordsApp);
      }
      const homeCoordinate=data[tenant][`area${tenantTypeFirstUpperCase}`]["recursiveHomeCoords"];
      if(homeCoordinate){
          let homeCoordApp=JSON.parse(homeCoordinate);
        setHomeArea({lat:homeCoordApp?.lat,lng:homeCoordApp?.lng})
      }else{
        setHomeArea(coordsApp[0])
      }
    }else{
       const homeCoordinate=data[tenant][`area${tenantTypeFirstUpperCase}`]["recursiveHomeCoords"];
        if(homeCoordinate) {
            let homeCoordApp = JSON.parse(homeCoordinate);
            setHomeArea({lat: homeCoordApp?.lat, lng: homeCoordApp?.lng})
        }

   }

  },
  notifyOnNetworkStatusChange: true, // did the work
});


React.useEffect(()=>{
  if(selectedNodes.length>0){
      setFormData({...formData,id: selectedNodes[0]})
      queryGetHome({variables: {id: selectedNodes[0]}})
  }
},[selectedNodes])


React.useEffect(()=>{
  if(formData.id!==undefined && color!==null){
    setMostraLayer(false);
  }
},[formData,color])


 var allShapes = []; //Contiene tutti i poligoni tracciati sulla mappa
 var selectedShape; //Poligono selezionato 
 

 /**
  * Funzione che ottiene il tracciato del documento passato per props e setta le configurazioni
  * Viene lanciata solo se siamo in modalità modifica di un tracciato
  */
 function getPoligoni() {
    queryGetHome({variables:{id: parseInt(props.match.params.id)}})
  } 

    /**
     * Funzione che permette il salvataggio dei tracciati distingunedo due casi:
     * props.match==undefined: Non stiamo modificando un tracciato quindi aggiungo un nuovo documento
     * props.mtch!=undefined: Stiamo modificando un tracciato, aggiorno l'array e il documento
     */
  function handleSave(){
   let coords = [];
      for(let j=0;j<allShapes.length;j++){ //Prendo il path di ogni poligono
        let path = allShapes[j].getPath();
        let coordsPoligono=[[]];
        for (let i = 0; i < path.length; i++) { //Per ogni path prendo le coordinate di ogni punto
          coordsPoligono[0].push([path.getAt(i).lng(),path.getAt(i).lat()])
        }
        coordsPoligono[0].push([path.getAt(0).lng(),path.getAt(0).lat()])
        //coordsPoligono[0].push([path[0].getAt(0).lat(),path[0].getAt(0).lng()])
        coords.push(coordsPoligono); //In percorso c'è un array contente le coordinate in formato lat e lng di ogni singolo poligono, l'array è un array di poligoni
      }
      
      const multiPolygonJSON={
        "type": "MultiPolygon",
        "crs": {
          "type": "name",
          "properties": {
            "name": "urn:ogc:def:crs:EPSG::4326"
          }
        },
        "coordinates": coords
      }
       savePolygon({variables:{id:formData.id,coordinates:JSON.stringify(multiPolygonJSON),color:color}})
      .then((value)=> {
          //  console.log("value",value);
         //   queryGetHome({variables: {id: formData.id}});
            window.location.href = window.location.origin + "/modificaTraccia/" + value['data'][`update_${tenant}_area_area${tenantType}_by_pk`]?.id
            alert("Area salvata correttamente");
          })
      .catch((error)=>{alert("Errore durante l'operazione");console.error(error)})
      if(props?.match?.params?.id !== formData?.id){
        savePolygon({variables:{id:props?.match?.params?.id,coordinates:null,color:null}})
              .then((value)=> {
         //   console.log("value",value);
            //queryGetHome({variables: {id: formData.id}});
            window.location.href = window.location.origin + "/modificaTraccia/" + value['data'][`update_${tenant}_area_area${tenantType}_by_pk`]?.id
            alert("Area salvata correttamente");
          })
      }
  }

  /**
   * Funzione che cancella il poligono selezionato
   */
  function deleteSelectedShape() {
    if (!selectedShape) {
      alert("Non ci sono poligoni selezionati");
      return;
    }

    if (window.confirm("Sei sicuro di voler eliminare il poligono selezionato?")) {
      var index = allShapes.indexOf(selectedShape);
      allShapes.splice(index, 1);
      selectedShape.setMap(null);
      
    }else{
      alert("Operazione annulata")
    }
  }

  /**
   * Componente che implementa il Drawing Manager
   */
    const MapWithADirectionsRenderer =()=>{

    const [libraries] = useState(['drawing']);
    const { isLoaded } = useJsApiLoader({
      id: 'google-map-script',
      libraries,
      googleMapsApiKey: "AIzaSyBH__gEjglI0DzkCuq33ioG3_ayXHP4ojo"
    })

    const onMapLoad = map => {};


    /**
     * Annulla la selezione dei poligoni
     */
    function clearSelection() {
      if (selectedShape) {
        selectedShape.setEditable(false);
        selectedShape = null;
      }
    }


    /**
     * Cambia poligono selezionato
     */
    function setSelection(shape) {
      clearSelection();
      selectedShape = shape;
      //labelList.push(labelBuca);
      shape.setEditable(true);
    }

    /**
     * Funzione che inizializza i listener che permetton l'aggiornamento dell'array contente
     * i nuovi tracciati
     */
    const onLoad = polygon => {
      var newShape = polygon;
      polygonRef.push(polygon.getPath().getArray());
      window.google.maps.event.addListener(polygon, 'click', function() {
        setSelection(newShape);
        window.google.maps.event.addListener(polygon.getPath(), 'insert_at', function() {

        });
        window.google.maps.event.addListener(polygon.getPath(), 'set_at', function() {

        });
      });
      allShapes.push(polygon);
      setSelection(newShape);
  }


    return isLoaded?(
      <GoogleMap
      center={new window.google.maps.LatLng(homeArea.lat,homeArea.lng)}
      zoom={16}
      onLoad={map => onMapLoad(map)}
      mapContainerStyle={{ height: "700px", width: "1000px" }}
    >
      <DrawingManager
        options={{
          drawingControl: true,
          drawingControlOptions: {
            style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: window.google.maps.ControlPosition.TOP_CENTER,
            drawingModes: [window.google.maps.drawing.OverlayType.POLYGON]
          },
          polygonOptions: {
            fillColor: color,
            fillOpacity: 0.2,
            strokeWeight: 2,
            strokeColor: color,
            clickable: true,
            editable: true,
            geodesic: false,
            visible: true,
            zIndex: 1
          }
        }}
        onOverlayComplete={(poly)=>{
          var newShape=poly.overlay;
          window.google.maps.event.addListener(newShape, 'click', function() {
            setSelection(newShape);
          });
          window.google.maps.event.addListener(newShape.getPath(), 'insert_at', function() {

          });
          window.google.maps.event.addListener(newShape.getPath(), 'set_at', function() {

          });
          allShapes.push(newShape);
          setSelection(newShape);
        }
      }
      />
            {
              poligoni.map((coordinata,index)=>{
                console.log(coordinata);
                return(
                <Polygon
                  key={index}
                  onLoad={onLoad}
                  paths= {coordinata.path}
                  editable={true}
                  zIndex={index}
                  strokeColor= {coordinata.color}
                  strokeOpacity={0.8}
                  strokeWeight={2}
                  fillColor= {coordinata.color}
                  fillOpacity={0.35}
                  >
                </Polygon>
              )}
              )
            }
    </GoogleMap>
    ):<></>}

  useEffect(() => {
    if (props.match) {
      getPoligoni();
    }
  }, []);

  
  const [width, setWidth]   = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
   /**
     * Funzione che permette di sapere le dimensioni aggiornate dello schermo
     */ 
  const updateDimensions = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
  }
  useEffect(() => {
      window.addEventListener("resize", updateDimensions);
      return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  /**
   * Controllo in base a width e height l'orientamento dello schermo.
   * Per essere respondive blocco la web app in LandScape.
   */
  React.useEffect(()=>{
    if(width<1100){
      if(width<height){
        setLandScapeError(true);
      }else{
        setLandScapeError(false);
      }    
    }
  },[width,height])

  const handleLabel=(label)=>{
      labelBuca=label;
  }

	return(
		<Grommet theme={theme} themeMode="dark" className="font-link">
      <ResponsiveContext.Consumer>
        {size => (
        <Box fill>
              <Box direction={width>=1100?"row":"column"}>
              {width>=1100?
                <SideBar pathLogo={props.match===undefined?"./images/Logo.png":props.match.params.id!==undefined?"../images/Logo.png":""} page="Geo ref." ruolo={(ruoli[0]!==undefined)?ruoli[0].Ruolo:null}/>      
            :  
            <AppBar position="static" style={{ background: '#397aa3'}}>
            <Toolbar>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                TimeMate
              </Typography>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={() => {
                 if(!showSideBarMob){
                  setShowSideBarMob(true);
                 }else{
                   setShowSideBarMob(false);
                 }      
                }}
              >
                <MenuIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
              }
               {showSideBarMob?
                  <SideBarMobile page="Attività" ruolo={(ruoli[0]!==undefined)?ruoli[0].Ruolo:null}/>
                 :
              <Box direction='column' flex overflow={{ horizontal: 'hidden' }} pad="small">
                  <Box direction="row" gap="small">
                    <Button style={{width:'150px',fontSize:'15px',background:"#397aa3",color:'white',fontWeight:'bold',textTransform: 'uppercase',borderStyle: 'solid',borderColor:'#397aa3',borderWidth:"3px", borderRadius:"10px"}} onClick={() =>
                    window.location.href = window.location.origin + "/home"}>
                      <Box pad="small" direction="row" align="center" gap="medium">
                          <LinkPrevious color="white"/>
                          <Text size="small" color="white">Indietro</Text>
                      </Box>
                    </Button> 
                    <Button style={{width:'250px',fontSize:'10px',background:"#ecedf3",color:'white',fontWeight:'bold',textTransform: 'uppercase',borderStyle: 'solid',borderColor:'#397aa3',borderWidth:"3px"}} onClick={()=>{setMostraLayerManual(true);setMostraLayer(true)}}>
                      <Box pad="small" direction="row" align="center" gap="medium">
                          <Text size="small" color="#397aa3">MOSTRA CONFIGURAZIONI</Text>
                      </Box>
                    </Button>
                      {
                          selectedShape &&  <Text></Text>
                      }

                  </Box>
                <Box flex direction='row' align="center" alignSelf="center">
                  <Box direction='column' pad="small" gap="medium">
                 
                      {formData && formData.id &&
                        <Box width="80%" >
                          <MapWithADirectionsRenderer />
                        </Box>
                      }
                  </Box>
                  {mostraLayer?
                  <Layer onClickOutside={()=>setMostraLayer(false)} onEsc={()=>setMostraLayer(false)}>
                    <Box style={{overflowX:"hidden"}} height={"80%"} width="50vw"  pad="medium" margin="small" direction='column' gap="small" >
                      <Text> Configurazione per Tracciamento: </Text>
                      <TreeViewAree checkAssignedAree={true} loadTree={queryGetTree} selectedNodes={selectedNodes} setSelectedNodes={setSelectedNodes} tree={tree} multiSelect={false} singleSelect={true}/>
                      {
                        /** <Select
                              placeholder="Tipologia Adl"
                              value={tipo}
                              disabled={props.match==undefined?false:true}
                              options={[... new Set(tipologie.map(tipologia => (tipologia)))]}
                              onChange={event => setTipo(event.target.value)}
                            />
                         * 
                         */
                      }

                    </Box>
                    <Box pad="small">
                      <Select
                          placeholder="Seleziona il Colore"
                          value={colorSelected}
                          disabled={props.match}
                          options={[... new Set(colors.map(colore => (colore.key)))]}
                          onChange={event =>
                            colors.filter(function(item){
                              if (item.key == event.target.value) {
                                setColorSelected(item.key);
                              }
                              return item.key == event.target.value;
                            }).map(function({value}){
                              setColor(value);
  
                            })
                          }
                      />
                    </Box>
                    <Button margin='2%' label="Chiudi" size="medium" onClick={() =>{ 
                      if(mostraLayerManual){
                        setMostraLayerManual(false);
                        setMostraLayer(false);
                      }else{
                        setMostraLayer(false)
                      }
                   }}  style={{fontSize:'20px',marginLeft: 'auto', marginRight: 'auto',background:'#ff0000',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}></Button>
                  </Layer>
                  :
                  null
                  }
                </Box>   
                <Box direction="row" gap="small" alignSelf="center" >
                  <Button label={props.match==undefined?"Salva":"Aggiorna"} size="medium" icon={<Location color="white"/>} onClick={() => handleSave()}  style={{fontSize:'20px',background:'#397aa3',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}></Button>
                  <Button label="Cancella poligono" size="medium" icon={<Close color="white"/>} onClick={() => deleteSelectedShape()}  style={{fontSize:'20px',background:'#ff0000',color:'white',fontWeight:'bold',textTransform: 'uppercase'}}></Button>
                </Box>
              </Box>
              }
            </Box>
        </Box>
        )}
      </ResponsiveContext.Consumer>
    </Grommet>   
	)}

export default Mappa;